import _ from 'lodash';
import { coordinationCenterNetwork } from 'src/common/utils/Group';

export default function isSuperNetwork(networks, groupId) {
  const network = coordinationCenterNetwork(networks, groupId);
  return _.get(network, 'is_super_network', false);
}
